import { render, staticRenderFns } from "./saldiscountoldpart.vue?vue&type=template&id=26005f0c&scoped=true&"
import script from "./saldiscountoldpart.vue?vue&type=script&lang=js&"
export * from "./saldiscountoldpart.vue?vue&type=script&lang=js&"
import style0 from "./saldiscountoldpart.vue?vue&type=style&index=0&id=26005f0c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26005f0c",
  null
  
)

export default component.exports